import { render } from "./AgendamentosCommonView.vue?vue&type=template&id=641c520c&scoped=true"
import script from "./AgendamentosCommonView.vue?vue&type=script&lang=js"
export * from "./AgendamentosCommonView.vue?vue&type=script&lang=js"

import "./AgendamentosCommonView.vue?vue&type=style&index=0&id=641c520c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-641c520c"]])

export default __exports__